import { render } from "./RankingQuestion.vue?vue&type=template&id=cda6ff4a&scoped=true"
import script from "./RankingQuestion.vue?vue&type=script&lang=js"
export * from "./RankingQuestion.vue?vue&type=script&lang=js"

import "./RankingQuestion.vue?vue&type=style&index=0&id=cda6ff4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda6ff4a"]])

export default __exports__